import { Badge } from '@oysterjs/ui/badge';

import { splitAtFieldReferences } from './field-chips';

/**
 * The text with each [[field]] as a sky chip, since Cara fills it in per email. Inside a button
 * (`surface="button"`) a chip would crowd the label, so the field is plain sky text there.
 */
export const FieldReferenceText = ({
  text,
  surface = 'theme'
}: {
  text: string;
  surface?: 'theme' | 'button';
}) => (
  <>
    {splitAtFieldReferences(text).map((part, index) => {
      if (!part.isFieldReference) {
        return part.text;
      }
      return surface === 'button' ? (
        // dark-mode-exempt: the button is light in both themes; sky-800 keeps AA on its tint.
        <span key={index} className="font-medium text-sky-800">
          {part.text}
        </span>
      ) : (
        <Badge key={index} color="sky">
          {part.text}
        </Badge>
      );
    })}
  </>
);
